'use client';

import { type HTMLAttributes, type ReactNode } from 'react';

import { clsx } from '@/libs';

type BottomFixedBodyProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
};

export const BottomFixedBody = ({
  children,
  className,
  ...props
}: BottomFixedBodyProps) => {
  return (
    <div className={clsx('w-full', className)} {...props}>
      {children}
    </div>
  );
};
